import { render, staticRenderFns } from "./unionCoopDetail.vue?vue&type=template&id=5c55ad03&scoped=true&"
import script from "./unionCoopDetail.vue?vue&type=script&lang=js&"
export * from "./unionCoopDetail.vue?vue&type=script&lang=js&"
import style0 from "./unionCoopDetail.vue?vue&type=style&index=0&id=5c55ad03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55ad03",
  null
  
)

export default component.exports